// extracted by mini-css-extract-plugin
export default {"dragAndDropContainer":"WkL9U","item":"Eq1aS","removeZone":"zRw49","itemIndex":"kKPDc","itemName":"gF2s_","itemInfoWrap":"gN7M0","itemInfo":"zR5Zl","btnAddRemove":"NXSK5"};